var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\xB0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M44.992 6.84799H39.424C39.616 9.02399 39.68 10.432 39.68 11.328C39.68 12.864 39.68 50.24 39.68 52.288C39.68 52.928 39.68 55.04 39.424 58.24H44.992C44.8 55.04 44.8 52.8 44.8 52.16C44.8 50.176 44.8 13.184 44.8 11.328C44.8 10.56 44.8 8.95999 44.992 6.84799Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M42 6.5V58.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M5.696 45.056V39.616C7.616 39.872 9.6 39.936 11.328 39.936H53.44C55.36 39.936 57.088 39.808 58.688 39.616V45.056C57.024 44.8 54.656 44.8 53.44 44.8H11.328C9.6 44.8 7.744 44.864 5.696 45.056Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M5.5 42.5H59",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M24.192 41.472H19.2V19.392H24.192V41.472Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    d: "M21.5 19V41.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    d: "M8.064 21.632V16.384C9.92 16.64 11.904 16.704 13.696 16.704H51.84C53.76 16.704 55.488 16.576 57.152 16.384V21.632C55.424 21.504 53.056 21.504 51.84 21.504H13.696C11.904 21.504 9.984 21.504 8.064 21.632Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_4",
    d: "M8 19H57.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWi);
export default __webpack_public_path__ + "static/media/wi.81a62ce2979042f007ad9cf171f592fe.svg";
export { ForwardRef as ReactComponent };